export default {
    textHeader: 'สแกน Qr code ลงชื่อเข้างาน',
    msgError: 'กรุณาสแกนใหม่อีกครั้ง',
    msgSuccess: 'ลงเวลาเข้างานสำเร็จ'
}
